import React from "react";
import { Check, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const benefits = [{
  title: "MAXIMISE ENERGY OUTPUT",
  description: "Regular cleaning can increase solar efficiency by up to 30%. We remove the 'shading' layer of dust and grime that blocks sunlight from reaching your cells."
}, {
  title: "Prevent Permanent Damage",
  description: "Bird droppings and debris cause 'hot spots' where cells overheat. Our professional service prevents these localized failures and extends your system's life."
}, {
  title: "Advanced Pure Water Tech",
  description: "We use deionised water and specialised soft brushes to ensure a spot-free finish without harsh chemicals or abrasive materials that could scratch the glass."
}];
export default function WhyChooseUs() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="25794" id="why-clean-your-panels" ref={sectionRef} className="relative w-full bg-background overflow-hidden">
      <div className="flex flex-col lg:flex-row min-h-[800px]">
        {}
        <div className="w-full lg:w-[60%] px-6 py-16 md:px-12 lg:px-20 xl:px-24 flex flex-col justify-center">
          <div className={cn("max-w-2xl transition-all duration-700 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
            <span className="inline-block py-1 px-4 rounded-full bg-primary/20 text-primary-foreground text-xs font-mono font-bold tracking-widest mb-6 uppercase">
              The Benefits
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6 tracking-tight font-sans">
              Why Professional Cleaning is Essential for Your Solar Investment
            </h2>
            <p className="text-lg text-muted-foreground mb-12 leading-relaxed">
              Accumulated dust, bird droppings, and environmental pollutants create an invisible barrier between the sun and your cells, costing you money every single day.
            </p>

            <div className="space-y-8">
              {benefits.map((benefit, index) => <div key={index} data-index={index} className={cn("flex gap-5 transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10")} style={{
              transitionDelay: `${index * 150}ms`
            }}>
                  <div className="shrink-0">
                    <div className="flex items-center justify-center size-14 rounded-2xl bg-secondary text-primary shadow-lg shadow-primary/5">
                      <Check className="size-7" strokeWidth={3} />
                    </div>
                  </div>
                  <div>
                    <h3 className="text-xl font-sans font-bold text-foreground mb-2 uppercase tracking-wide">
                      {benefit.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>)}
            </div>

            <div className="mt-12 pt-6 border-t border-border/50">
              <Button asChild size="lg" className="text-base px-10 rounded-full bg-primary hover:bg-primary/90 text-primary-foreground shadow-xl shadow-primary/20 transition-all">
                <Link to="/ContactUsPage">
                  Request a Free Quote <ArrowRight className="ml-2 size-4" />
                </Link>
              </Button>
            </div>
          </div>
        </div>

        {}
        <div className="w-full lg:w-[40%] relative min-h-[400px] lg:min-h-auto overflow-hidden">
          <div className="absolute inset-0 bg-cover bg-center bg-no-repeat lg:bg-fixed" style={{
          backgroundImage: "url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1585875/img/modern_brisbane_office_space.png')"
        }}>
            {}
            <div className="absolute inset-0 bg-primary/5 mix-blend-overlay" />
            <div className="absolute inset-0 bg-gradient-to-t from-background/20 to-transparent" />
          </div>
        </div>
      </div>
    </section>;
}